import { Box, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { FORTA_GRAY4, FORTA_BLUE, FORTA_WHITE } from '../../../../../../../utils/colors';
import { FHTooltip } from '../../../../../../../components/base';

interface ICheckIconLabelProps {
  label: string;
  checked?: boolean;
  tooltipContent?: string;
  sx?: any;
}

function CheckIconLabel({ label, checked, tooltipContent, sx = {} }: ICheckIconLabelProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, ...sx }}>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ width: '24px', height: '24px' }}>
          {checked && <CheckRoundedIcon sx={{ color: FORTA_BLUE.primary }} />}
        </Box>
        <Typography
          textAlign="left"
          fontSize={14}
          fontWeight={checked ? 700 : 400}
          ml={1.5}
          color={FORTA_GRAY4}
        >
          {label}
        </Typography>
      </Box>
      {tooltipContent && (
        <FHTooltip title={tooltipContent} arrow tooltipbackground={FORTA_WHITE}>
          <InfoOutlinedIcon fontSize="small" style={{ color: FORTA_BLUE.primary }} />
        </FHTooltip>
      )}
    </Box>
  );
}

export default CheckIconLabel;
